import React, { useEffect, useMemo, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import { AppStore } from 'src/pc/store/AppStore'
import { getUpgradeVipInfoHS } from 'src/commons/store/UserStore'
import { subtract, commonJump } from 'src/pc/store/UIController'
import { useLocalStorageState } from 'ahooks'
import { autorun } from 'mobx'
import { checkNewcomerWelfareModal } from 'src/pc/pages/activity/components/newcomer-welfare-modal'
import NewcomerWelfareModal from 'src/pc/pages/activity/components/newcomer-welfare-modal'
import styled from 'styled-components'
import DDModal from 'src/pc/components/DDModal'

import modalBg from 'src/pc/assets/images/vip-center/update-modal-bg.png'
import btnBg from 'src/pc/assets/images/vip-center/update-btn-bg.png'
import timeImg from 'src/pc/assets/images/vip-center/update-time-icon.png'
import Cookies from 'js-cookie'
import close from 'src/pc/assets/images/red-envelopes/close.png'

//升级vip3天倒计时
const UPGRADE_VIP_COUNT_DOWN_TIME = 1000 * 3600 * 24 * 3

const UpdateVipModal: React.FC = () => {
  const [upgradeVipCountdown, setUpgradeVipCountdown] = useState({ days: '', hours: '', minutes: '', seconds: '' })
  //循环3天倒计时
  const [upgradeVipEndTime, setUpgradeVipEndTime] = useLocalStorageState('UPGRADE_VIP_END_TIME', {
    defaultValue: 0,
  })
  const timerRef = useRef<number>(0)

  const upgradeVipInfo = getUpgradeVipInfoHS.SuccessResult

  const cancel = () => {
    timerRef.current && window.clearInterval(timerRef.current)
    AppStore.updateVipModalVisible = false
  }

  const visible = AppStore.updateVipModalVisible

  //抵扣后的金额
  // const finalAmt = useMemo(() => {
  //   return Math.max(0, subtract(upgradeVipInfo?.salePrice ?? 0, Number(upgradeVipInfo?.availableDiscount ?? 0)))
  // }, [upgradeVipInfo])

  const calcCountdown = (endTime: number) => {
    const startTime = new Date().getTime()
    const time = endTime - startTime
    if (time <= 1000) {
      timerRef.current && window.clearInterval(timerRef.current)
      console.log('倒计时结束')
      setUpgradeVipEndTime(new Date().getTime() + UPGRADE_VIP_COUNT_DOWN_TIME)
      return
    }
    let days = Math.floor(time / 3600 / 24 / 1000)
    days = Math.max(0, days)
    const hours = parseInt(`${Math.max(0, (time % (1000 * 3600 * 24)) / (1000 * 3600))}`)
      .toString()
      .padStart(2, '0')
    const minutes = parseInt(`${Math.max(0, (time % (1000 * 3600)) / (1000 * 60))}`)
      .toString()
      .padStart(2, '0')
    const seconds = parseInt(`${Math.max(0, (time % (1000 * 60)) / 1000)}`)
      .toString()
      .padStart(2, '0')
    setUpgradeVipCountdown({ days: String(days), hours, minutes, seconds })
  }

  useEffect(() => {
    if (!visible) {
      return
    }

    let endTime = upgradeVipEndTime
    if (!endTime) {
      endTime = new Date().getTime() + UPGRADE_VIP_COUNT_DOWN_TIME
      setUpgradeVipEndTime(endTime)
    }
    calcCountdown(endTime)
    timerRef.current && window.clearInterval(timerRef.current)
    timerRef.current = window.setInterval(() => {
      calcCountdown(endTime)
    }, 1000)
    return () => {
      timerRef.current && window.clearInterval(timerRef.current)
    }
  }, [visible, upgradeVipEndTime])

  useEffect(() => {
    if (visible) {
      window.gogReport?.('ShareUpdateVip_PopupWindow_View')
      const updateVipNum = localStorage.getItem(`update-vip-modal-num`)
      localStorage.setItem('update-vip-modal-num', `${Number(updateVipNum || 0) + 1}`)
      Cookies.set('update-vip-modal', '1', { expires: 1 })
    }
  }, [visible])

  return (
    <>
      <StyledModal
        visible={visible}
        width={327}
        className="custom-1 UpgradeModal"
        closable={false}
        centered
        maskClosable={false}
        title={null}
        footer={null}
        bg={AppStore.upgradeVipConfig?.activityConfig.UpgradeVipModalBg || ''}
      >
        <StyledCostPriceText>原价</StyledCostPriceText>
        <StyledCostPrice>
          <span>¥</span>
          {upgradeVipInfo?.salePrice}
        </StyledCostPrice>
        <StyledSalePriceText>特权价</StyledSalePriceText>
        <StyledSalePrice>
          <span>低至¥</span>
          {AppStore.upgradeVipConfig?.activityConfig?.lowestSalePrice}
        </StyledSalePrice>
        <StyledBtn
          onClick={() => {
            window.gogReport?.('ShareUpdateVip_PopupWindow_Click')
            cancel()
            commonJump('/vip?referer=homeModal')
          }}
        >
          <div className="top-text">去升级</div>
          <div className="downCount">
            <img src={timeImg} alt="" />
            <div className="num-box">{upgradeVipCountdown.days}</div>天
            <div className="num-box">{upgradeVipCountdown.hours}</div>时
            <div className="num-box">{upgradeVipCountdown.minutes}</div>分
            <div className="num-box">{upgradeVipCountdown.seconds}</div>秒
          </div>
        </StyledBtn>
        <StyledClose onClick={() => cancel()}>
          <img draggable={false} src={close} />
        </StyledClose>
      </StyledModal>
      <NewcomerWelfareModal />
    </>
  )
}

/**
 * 是否显示活动弹窗
 */
export const checkUpdateVipModal = async () => {
  const flag = Cookies.get('update-vip-modal')
  let upgradeVipInfo = getUpgradeVipInfoHS.SuccessResult
  upgradeVipInfo = await new Promise(resolve => {
    if (!upgradeVipInfo && !getUpgradeVipInfoHS.FailedResult) {
      const disposer = autorun(() => {
        if (getUpgradeVipInfoHS.SuccessResult || getUpgradeVipInfoHS.FailedResult) {
          disposer()
          resolve(getUpgradeVipInfoHS.SuccessResult)
        }
      })
    } else {
      resolve(upgradeVipInfo)
    }
  })
  const isUpgrade = !!upgradeVipInfo?.eligible && !upgradeVipInfo?.participated
  const visible = isUpgrade && !flag && ['/', '/home'].includes(location.pathname) && !!AppStore.upgradeVipConfig
  if (visible) {
    const newcomerWelfareFlag = checkNewcomerWelfareModal()
    if (newcomerWelfareFlag) {
      AppStore.newcomerWelfareModalVisible = true
      return
    }
    AppStore.updateVipModalVisible = visible
  }
  return visible
}

const StyledClose = styled.div`
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
`
const StyledBtn = styled.div`
  width: 203px;
  height: 51px;
  background: url(${btnBg});
  background-size: 100% 100%;
  position: absolute;
  top: 388px;
  left: 63px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    filter: brightness(1.1);
  }
  img {
    margin-right: 7px;
  }
  .downCount {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c11d40;
    font-size: 14px;
    height: 16px;
    line-height: 16px;
  }
  .top-text {
    color: #5d090e;
    font-size: 18px;
    height: 18px;
    line-height: 18px;
    margin-bottom: 5px;
    font-weight: bold;
  }
`
const StyledSalePrice = styled.div`
  font-size: 36px;
  color: #ffcc74;
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 293px;
  left: 138px;
  font-weight: bold;
  width: 154px;
  justify-content: center;
  span {
    font-size: 16px;
    position: relative;
    top: -8px;
    font-weight: normal;
  }
`
const StyledSalePriceText = styled.div`
  position: absolute;
  font-size: 16px;
  color: #ffffff;
  top: 266px;
  left: 191px;
`
const StyledCostPrice = styled.div`
  font-size: 24px;
  color: rgba(255, 255, 255, 0.5);
  position: absolute;
  display: flex;
  align-items: flex-end;
  top: 312px;
  left: 61px;
  span {
    font-size: 16px;
    position: relative;
    top: -3px;
  }
`
const StyledCostPriceText = styled.div`
  position: absolute;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  top: 285px;
  left: 72px;
`
const StyledModal = styled(DDModal)<{ bg: string }>`
  .ant-modal-content {
    background: url(${prop => prop.bg || modalBg}) no-repeat;
  }
  .ant-modal-body {
    background: none;
    padding-top: 60px;
    height: 470px;
  }
  .ant-modal-close-x {
    display: none;
  }
`

export default observer(UpdateVipModal)
